import { z } from "zod";
import { useState, useEffect } from "react";
import { FormState } from "./FormState";
import { FieldProps } from "react-final-form";
import { SelectField, InputField, CheckboxField, FormBase, FormSubmitCallback } from "ui";
import { customfieldOptionType } from "../../constants/SelectFieldOpts";
export const NEW_CUSTOMFIELD_FORM_FIELDS: FieldProps<string, any>[] = [
    {
        name: "type",
        label: "Type",
        required: true,
        fullWidth: true,
        component: SelectField,
        options: customfieldOptionType,
        grid: { xs: 12 }
    },
    {
        name: "name",
        label: "Name",
        required: true,
        fullWidth: true,
        component: InputField,
        grid: { xs: 12 }
    },
    {
        name: "description",
        label: "Description",
        required: true,
        fullWidth: true,
        component: InputField,
        grid: { xs: 12 }
    },
    {
        name: "required",
        label: "Required",
        fullWidth: true,
        component: CheckboxField,
        grid: { xs: 12 }
    }
]
export const newCustomFieldSchema = z.object({
    type: z.enum(["TEXT", "SELECT"]),
    name: z.string().trim().max(255).min(1),
    description: z.string().trim().max(255).min(1),
    required: z.coerce.boolean().default(false)
})

export type NewCustomFormSchema = z.infer<typeof newCustomFieldSchema>
export type CustomFormProps = {
    onSubmit: (values: NewCustomFormSchema) => Promise<ReturnType<FormSubmitCallback>>
    onCancel: () => void
}
function NewCustomFieldForm({ onSubmit, onCancel }: CustomFormProps) {
    const [formState, setFormState] = useState<FormState>({ fields: NEW_CUSTOMFIELD_FORM_FIELDS })
    useEffect(() => {
        const fields = [...NEW_CUSTOMFIELD_FORM_FIELDS]
        setFormState(prevState => ({
            ...prevState,
            fields
        }))
    }, [])

    const EditForm = FormBase<NewCustomFormSchema>({
        fields: formState.fields,
        initialValues: {},
        validationSchema: newCustomFieldSchema,
        buttonSubmitLabel: "Save",
        buttonCancelLabel: "Cancel",
        // readonly,
        onSubmit: onSubmit,
        onCancel: onCancel
    })

    return EditForm;
};

export default NewCustomFieldForm